import { Component, Inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'acs-yes-no-dialog',
  templateUrl: './yes-no-dialog.component.html'
})
export class YesNoDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      content: string;
      confirmText: string;
      denyText: string;
      includeCancel: boolean;
    },
    private dialogRef: MatDialogRef<YesNoDialogComponent>
  ) {}

  public onNoClick(): void {
    this.dialogRef.close();
  }
}
